import FeatureTitle from './FeatureTitle'

export default FeatureTitle
